import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const updateCampaignTriggers = async (domain: string, campaignId: number, triggerType: "manual" | "timed", triggerTime?: Date): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/triggers`,
        method: 'POST',
        params: {
            triggerType,
            triggerTime,
        },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}